<template>
	<header>
		<div id="nav">
			<div class="main">
                
                <div class="toggle" id="menuToggle">
                    
                    <input type="checkbox"/>
                    <span></span>
                    <span></span>
                    <span></span>
                    
                    <ul id="menu">
                        <li class="menuList">
    
                            <div class="logo">
        
                                <img width="100%" src="img/logo.png" alt="">
                            </div>
                            <router-link to="/">Accueil</router-link>
                            <router-link to="/about">A Propos</router-link>
                            <router-link to="/shop">Recherche</router-link>
                            <router-link to="/account">Compte</router-link>
                            <router-link to="/cart">Favoris</router-link>
                        </li>
                    </ul>
                
                </div>
                <router-link to="/">
                <div class="logo">
                    
                    <img width="100%" src="img/logo.png" alt="">
                </div>
                </router-link>
            </div>
			<div class="compte_container" v-if="$route.name!=='Account'">
              
                <div class="isLog" v-if="user">
                    <router-link to="/profil">Profil</router-link>
                    <button @click="logout()">Deconnexion</button>
                </div>
                <div class="nolog" v-else>
                    <router-link  to="/account">Connexion</router-link>
                </div>
            </div>
		</div>
	</header>
</template>

<script>
	import ApiProducts from "@/mixins/ApiProducts";
	import ApiAuthentication from "@/mixins/ApiAuthentication";
	
	export default {
		name: "Header",
		data: function () {
			return {
                user:null
			}
		},
		methods: {
			// getProducts : function() {
			//     return   fetch('https://fakestoreapi.com/products/')
			//     .then(res => res.json())
			// }
            logout(){
                this.logoutSession(this.getSession(this.$store.state.user.token))
              
            }
		},
		mounted() {
		},
		computed: {
		    
        },
		watch: {
		user:function(){
		    this.$store.state.user.data
        }
		},
		mixins: [ApiProducts,ApiAuthentication]
		
	}
</script>

<style lang="scss" scoped>
	#nav {
		display: flex;
		flex: 1;
		justify-content: space-between;
		padding: 5px 20px;
        align-items: center;
		position: relative;
		
		a {
			font-weight: bold;
			display: block;
			padding: 20px;
			transition: .3s;
		}
  
		.main{
            display: flex;
            align-items: center;
        }
		.logo {
            padding: 0 10px;
            /*z-index: 100;*/
		}
        .search__form{
        
        }
        .compte_container{
            display: flex;
            position:relative;
            right:20px;
           
            a{
                color:white;
                text-decoration: none;
            }
            a:hover{
                color: #9c0204;
            }
            .isLog{
                display: flex;
                align-items: center;
                align-content: center;
            }
            button{
                padding:10px;
                border:1px solid white;
                background:none;
                color:white;
                font-weight: bold;
                height: max-content;
                transition:.3s;
               
            }
            button:hover{
                cursor: pointer;
                background: #9c0204;
                border:1px solid #9c0204;
    
            }
        }
		
		#menuToggle {
			display: block;
			position: relative;
			
			z-index: 1;
			
			-webkit-user-select: none;
			user-select: none;
		}
  
		#menuToggle a{
			text-decoration: none;
			color: #e5e5e5;
			
			transition: color 0.3s ease;
		}
		
		#menuToggle a:hover {
			color: #9c0204;
		}
		
		
		#menuToggle input{
			display: block;
			width: 40px;
			height: 32px;
			position: absolute;
			top: -7px;
			left: -5px;
			
			cursor: pointer;
			
			opacity: 0; /* hide this */
			z-index: 2; /* and place it over the hamburger */
			
			-webkit-touch-callout: none;
		}
    
  
		
		/*
		 * Just a quick hamburger
		 */
		#menuToggle span{
			display: block;
			width: 30px;
			height: 3px;
			margin-bottom: 5px;
			position: relative;
			
			background: #e5e5e5;
			
			z-index: 1;
			
			transform-origin: 4px 0px;
			
			transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0),
			background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0),
			opacity 0.55s ease;
		}
  
		#menuToggle span:first-child{
			transform-origin: 0% 0%;
   
		}
		
		#menuToggle span:nth-last-child(2){
			transform-origin: 0% 100%;
   
		}
		
		/*
		 * Transform all the slices of hamburger
		 * into a crossmark.
		 */
		#menuToggle input:checked ~ span{
			opacity: 1;
			transform: rotate(45deg) translate(-2px, -2px);
			background: #e5e5e5;
            height: 3px;
            width: 30px;
            border-radius: 0;
        }
		
		/*
		 * But let's hide the middle one.
		 */
		#menuToggle input:checked ~ span:nth-last-child(3) {
			opacity: 0;
			transform: rotate(0deg) scale(0.2, 0.2);
        
        }
		
		/*
		 * Ohyeah and the last one should go the other direction
		 */
		#menuToggle input:checked ~ span:nth-last-child(2) {
			transform: rotate(-45deg) translate(2px,0px);
            height: 3px;
            width: 30px;
            border-radius: 0;
		}
		
		/*
		 * Make this absolute positioned
		 * at the top left of the screen
		 */
		#menu{
			position: absolute;
			margin: -57px 0 0 -30px;
			height: 100vh;
            padding:0;
			background: #0d0d0d;
			list-style-type: none;
			-webkit-font-smoothing: antialiased;
			/* to stop flickering of text in safari */
			
			transform-origin: 0% 0%;
			transform: translate(-100%, 0);
			transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0);
   .menuList{
       margin-top: 80px;
   }
		}
  
		
		#menu li {
			padding: 10px 0;
			font-size: 22px;
		}
		
		/*
		 * And let's slide it in from the left
		 */
		#menuToggle input:checked ~ ul{
			transform: none;
		}
	}
</style>